<template>

<span
	class="mark"
	:style="frameStyle"
	:role="label ? 'img' : null"
	:aria-label="label || null"
	:aria-hidden="label ? null : 'true'"
>
	<span class="mark-grid" :style="gridStyle">
		<span class="mark-tile" :style="tileStyle(true)"></span>
		<span class="mark-tile" :style="tileStyle(false)"></span>
		<span class="mark-tile" :style="tileStyle(false)"></span>
		<span class="mark-tile" :style="tileStyle(true)"></span>
	</span>
</span>

</template>

<script>

/*
	The whatboxart mark: a rounded square "frame" holding a 2x2 grid of tiles in
	a checker pattern (top-left + bottom-right ink, top-right + bottom-left warm
	neutral) — a partially-revealed tile grid over box art. Everything scales off
	the single `size` prop so the mark works at hero, topbar, and favicon sizes
	and stands alone as an app icon. Pass `label` to make it a standalone image
	(otherwise it's decorative, for use inside the wordmark lockup).

	No gradients, no shadows, gentle radii only — editorial, light-theme.
*/

var INK = '#1c1a16'
var NEUTRAL = '#cfc6b4'

export default {

	props: {
		size: {
			default: 38
		},
		label: {
			default: ''
		}
	},

	computed: {

		s: function() {

			return Number(this.size) || 38

		},

		// ratios from the hero spec (38px: border 1.5, radius 6, pad 5)
		frameStyle: function() {

			var s = this.s

			return {
				width: s + 'px',
				height: s + 'px',
				borderRadius: (s * 0.158).toFixed(2) + 'px',
				border: Math.max(1.25, s * 0.04).toFixed(2) + 'px solid ' + INK,
				padding: (s * 0.131).toFixed(2) + 'px'
			}

		},

		gridStyle: function() {

			return {
				gap: (this.s * 0.079).toFixed(2) + 'px'
			}

		}

	},

	methods: {

		tileStyle: function(ink) {

			return {
				background: ink ? INK : NEUTRAL,
				borderRadius: (this.s * 0.04).toFixed(2) + 'px'
			}

		}

	}

}

</script>

<style scoped>

.mark {
	display: inline-flex;
	box-sizing: border-box;
	flex: none;
	background: transparent;
}

.mark-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 1fr 1fr;
	width: 100%;
	height: 100%;
}

.mark-tile {
	display: block;
}

</style>
